module.exports = __webpack_public_path__ + "static/screenRecording@2x-1b11312c21f48d8ef30f9fc4eb7e3aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/screenRecording@2x.png
// module id = 2618
// module chunks = 168707334958949